import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header.tsx";
import { MoreInfo } from "@/components/onboarding/more-info.tsx";
import { format } from "date-fns";
import { getAge } from "@/lib/utils";
import { User } from "@/lib/api/user";
import { Badge } from "../ui/badge";

export const columns: ColumnDef<User>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      const name = row.original.name;

      return (
        <div className="flex items-center gap-2">
          <div className="font-bold">{name}</div>
        </div>
      );
    },
  },
  {
    accessorKey: "phone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Phone" />
    ),
    enableHiding: false,
    enableSorting: false,
    cell: ({ row }) => <div className="text-center">{row.original.phone}</div>,
  },
  {
    accessorKey: "state",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="State" />
    ),
    enableHiding: false,
    enableSorting: false,
    cell: ({ row }) => (
      <div className="text-center">{row.original.profile?.metadata?.state}</div>
    ),
  },
  {
    accessorKey: "age",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Age" />
    ),
    enableHiding: false,
    enableSorting: false,
    cell: ({ row }) => {
      const birthday = row.original.birthday
        ? new Date(row.original.birthday)
        : undefined;

      return (
        <div className="text-center">
          {birthday ? getAge(birthday.toISOString()) : "-"}
        </div>
      );
    },
  },
  {
    accessorKey: "sex",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Sex" />
    ),
    cell: ({ row }) => {
      const sex = row.original.profile?.sex;

      return <div className="text-center">{sex}</div>;
    },
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "created-at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created At" />
    ),
    cell: ({ row }) => {
      const createdAt = row.original.created_at;

      return (
        <div className="text-center">
          {createdAt ? format(new Date(createdAt), "d MMM yyyy, h:mm a") : ""}
        </div>
      );
    },
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "mentor-match",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Mentor Match" />
    ),
    cell: ({ row }) => {
      const mentor = row.original.metadata?.onboarding?.mentor?.name;

      return <div className="text-center">{mentor}</div>;
    },
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "exit-screen",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Exit Screen" />
    ),
    cell: ({ row }) => {
      const exitScreen = row.original.metadata?.onboarding?.screen;

      return <div className="text-center">{exitScreen}</div>;
    },
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "onboarding-completed",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Onboarding" />
    ),
    cell: ({ row }) => {
      const onboardingCompleted = row.original.has_onboarded;

      return (
        <div className="text-center">
          <Badge variant={onboardingCompleted ? "secondary" : "destructive"}>
            {onboardingCompleted ? "Done" : "Not Finished"}
          </Badge>
        </div>
      );
    },
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "more-info",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="More Info" />
    ),
    cell: ({ row }) => {
      const moreInfo = row.original;

      return <MoreInfo data={moreInfo} />;
    },
    enableHiding: false,
    enableSorting: false,
  },
];
